document.addEventListener("DOMContentLoaded", function () {
  // Function to display active filters
  if (document.getElementById("active-filter-list")) {
  function updateActiveFilters() {
    const activeFiltersContainer =
      document.getElementById("active-filter-list");

    // Clear previous active filters
    activeFiltersContainer.innerHTML = "";

    // Get all active filters (Facets)
    const activeFacets = document.querySelectorAll(
      ".facetwp-facet .facetwp-checkbox.checked"
    );

    // If there are active filters, display them
    if (activeFacets.length > 0) {
      activeFacets.forEach((facet) => {
        const facetLabel = facet
          .querySelector(".facetwp-display-value")
          .textContent.trim();

        console.log(facet);

        // Create an element for each active filter
        const filterItem = document.createElement("div");
        filterItem.classList.add("active-filter-item");

        const label = document.createElement("span");
        label.textContent = facetLabel;
        filterItem.appendChild(label);

        // Create a close button to remove the filter
        const closeButton = document.createElement("button");
        closeButton.classList.add("remove-filter");
        closeButton.textContent = "×";
        filterItem.appendChild(closeButton);

        // Add click event to remove the filter
        closeButton.addEventListener("click", function () {
          facet.click(); // Uncheck the filter
        });

        // Add the filter item to the active filters list
        activeFiltersContainer.appendChild(filterItem);
      });
    } else {
    }
  }

  // Listen for FacetWP load event and when facets are updated
  document.addEventListener("facetwp-loaded", function () {
    updateActiveFilters(); // Update active filters when FacetWP is loaded or updated
  });

  // Optionally, you could also trigger this function on page load in case filters are pre-selected
  updateActiveFilters();
}
});
